import BaseHttpService from "./baseHttpService";
import { convertState, convertCity } from "../commons/utils/convertLocation";
import { convertText } from "../commons/utils/convertText";

import { Config } from "../env";
import { AxiosResponse } from "axios";

export default class WishlistService extends BaseHttpService {
    getWishList = async (limit?: number, offset?: number) => {
        return this.get(
            `${Config.API_WISHLIST_URL}/alert${
                limit && offset ? `/?limit=${limit}&offset=${offset}` : ""
            }`
        );
    };
    deleteWishList = async (id) => {
        return this.delete(`${Config.API_WISHLIST_URL}/alert/${id}`);
    };
    postWishList = async (payload) => {
        return this.post(`${Config.API_WISHLIST_URL}/alert`, payload);
    };
    putWishList = async (id, payload) => {
        return this.patch(`${Config.API_WISHLIST_URL}/alert/${id}`, payload);
    };
    deleteAllAlertsWishList = async (payload) => {
        return this.deleteAllAlerts(
            `${Config.API_WISHLIST_URL}/alert`,
            payload
        );
    };
    getSearch = async (text) => {
        return this.get(`${Config.API_WISHLIST_URL}/search/?carModel=${text}`);
    };

    getCountProducts(
        brand,
        model,
        location,
        yearStart,
        yearEnd,
        priceStart,
        priceEnd
    ) {
        const arrQuery = [];

        if (location.length) {
            const arrState = [];
            const arrCity = [];

            location.forEach((loc, l) => {
                arrState.push(convertState(loc.state));
                arrCity.push(convertCity(loc.city));
            });

            arrQuery.push(`product.location.state:[${arrState.join(",")}];`);
            arrQuery.push(`product.location.city:[${arrCity.join(",")}];`);
        }

        if (brand && brand !== "undefined") {
            arrQuery.push(
                `product.brand.description:${convertText(brand.toLowerCase())};`
            );
        }

        if (model && model !== "undefined") {
            arrQuery.push(
                `product.model.description:${convertText(model.toLowerCase())};`
            );
        }

        if (
            priceStart &&
            priceStart !== "undefined" &&
            priceEnd &&
            priceEnd !== "undefined"
        ) {
            arrQuery.push(`price:range[${priceStart}TO${priceEnd}];`);
        }

        if (
            yearStart &&
            yearStart !== "undefined" &&
            yearEnd &&
            yearEnd !== "undefined"
        ) {
            arrQuery.push(
                `product.template.aggs.identificacao.anofabricacao:range[${yearStart}TO${yearEnd}];`
            );
        }

        let query = "";

        if (arrQuery.length) {
            query = arrQuery.join("");
        }
        return this.get(
            `https://api.sbwebservices.net/offer-query/offers/?locale=pt_BR&timeZoneId=America%2FRecife&portalId=[2,15]&filter=${query}product.subCategory.category.description:carros&searchType=opened&pageNumber=0&pageSize=0&orderBy=price:desc&requestOrigin=marketplace`
        );
    }

    getLocation(searchTerm: string): Promise<AxiosResponse> {
        return this.get(
            `${Config.API_WISHLIST_URL}/search/location?term=${searchTerm}`
        );
    }
}
